import { PlayerContext } from "backend/src/common/types/ExtensionCard";
import { PlayerModelType } from "store/models/Player";
import { getRoomContext } from "./getRoomContext";

export const getPlayerContext = (player: PlayerModelType): PlayerContext => ({
  ...getRoomContext(),
  player,
});
